import axios from 'axios';

import configs from 'config';
import { getAppInfo, getURLParameter, getAppVersion, CleverTapEventV2, CLEVERTAP, nativeHandler } from 'utils';
import globalConstant from 'constants/globalConstant';
import MESSAGE_CONSTANT from 'constants/msgConstant';

const Request = axios.create({
	baseURL: configs.loans,
	headers: { 'Content-Type': 'application/json' },
});

const serializeError = (error) => {
	const { response } = error;
	if (!response) throw error;
	const { status, statusText, data } = response;
	const { message } = data;
	let errorMsg = '';
	try {
		errorMsg = JSON.parse(message).error.debug_msg;
	} catch (e) {
		errorMsg = message;
	}
	if (status?.toString() === '503') {
		CleverTapEventV2.send(CLEVERTAP.EVENTS.API_ERROR_503, {
			api_url: `${response?.config?.baseURL}${response?.config.url}`,
		});
	}
	const errorObj = {
		name: 'API ERROR',
		message: errorMsg || statusText || MESSAGE_CONSTANT.SOMETHING_WRONG,
		code: status.toString(),
		stack: JSON.stringify(error.toJSON()),
		response: response,
	};
	return errorObj;
};

const tokenHeaderInterceptor = (config) => {
	var visa =
		getAppInfo()?.[globalConstant.URL_PARAMETER.TOKEN] ||
		getAppInfo()?.[globalConstant.URL_PARAMETER.VISA] ||
		getURLParameter(globalConstant.URL_PARAMETER.TOKEN);
	config.headers['token'] = visa;
	config.headers['latitude'] = getAppInfo()?.latitude || getURLParameter(globalConstant.URL_PARAMETER.LATITUDE) || '';
	config.headers['longitude'] =
		getAppInfo()?.longitude || getURLParameter(globalConstant.URL_PARAMETER.LONGITUDE) || '';
	config.headers['installid'] = getAppInfo()?.[globalConstant.URL_PARAMETER.INSTALL_ID] || '';
	config.headers['device'] = getAppInfo()?.[globalConstant.URL_PARAMETER.DEVICE_ID] || '';
	config.headers['simid'] = getAppInfo()?.[globalConstant.URL_PARAMETER.SIM_ID] || '';
	config.headers['appversion'] = getAppVersion() || '';
	return config;
};

const onErrorInterceptor = (error) => {
	const { response } = error;
	const { status } = response;
	if (
		status?.toString() === '401' &&
		getURLParameter(globalConstant.URL_PARAMETER.WROUTE) !== globalConstant.WROUTE.TNC
	) {
		localStorage.clear();
		nativeHandler.logout();
	}
	throw serializeError(error);
};

Request.interceptors.request.use(tokenHeaderInterceptor);
Request.interceptors.response.use(undefined, onErrorInterceptor);

const extractor = (response) => {
	const { status, data, statusText } = response;
	if (status !== 200) throw new Error(statusText);
	return data;
};

export const get = (path, params) => Request.get(path, { params }).then(extractor);

export const post = (path, payload) => Request.post(path, payload).then(extractor);

export const put = (path, payload) => Request.put(path, payload).then(extractor);
